/**
 * Created by ok on 4/25/16.
 */
import React from 'react';
import styled from 'styled-components';

const Heading = ({ text, level, classes, center, margin, children, sans, striped, id }) => {
    const HeadingLevel = `h${level}`;
    classes = classes || '';

    const StyledHeader = styled[HeadingLevel]`
        color: ${props => props.theme.palette.primary[800]};
        text-align: ${center === true ? 'center' : 'left'};
        margin: ${margin || '1.31rem 0 0.62rem 0'};
        font-family: ${sans ? props => props.theme.font : props => props.theme.serif};
        transition: all 300ms;
    `;

    const Stripe = styled.div`
        background-color: ${props => props.theme.palette.secondary.A500};
        height: 5px;
        width: 3rem;
        margin: 0.3rem 0 1rem;
    `;

    return (
        <React.Fragment>
            <StyledHeader className={classes} key={Date.now()} id={id}>
                {text}
                {children}
                {striped && <Stripe />}
            </StyledHeader>

        </React.Fragment>
    );
};

export default Heading;



// WEBPACK FOOTER //
// ./src/components/heading/Heading.js